import PhonePreview from '@/src/components/molecule/PhonePreview';

interface MagazinePreviewProps {
  contentsMarkup: string;
}

export default function MagazinePreview({
  contentsMarkup,
}: MagazinePreviewProps) {
  return (
    <div className="w-[400px] flex-shrink-0">
      <PhonePreview>
        <div className="sticky top-0 z-10">
          <img
            src="/assets/images/img-magazine-header-preview.png"
            alt="img-notice-header-preview"
            width="100%"
            height="auto"
          />
        </div>
        <PhonePreview.Content className="p-0">
          <div
            className="ck-content"
            dangerouslySetInnerHTML={{
              __html: contentsMarkup,
            }}
          />
        </PhonePreview.Content>
      </PhonePreview>
    </div>
  );
}
